import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';

import { calcDaysLeft } from '../../utils';

interface SearchDonationCardProps {
  businessId: number;
  thumbnailUrl: string;
  title: string;
  institutionName: string;
  endDate?: string;
  donationAmount: number;
  achievementRate: number;
  isEnded?: boolean;
}

export function SearchDonationCard({
  businessId,
  thumbnailUrl,
  title,
  institutionName,
  endDate,
  donationAmount,
  achievementRate,
  isEnded,
}: SearchDonationCardProps) {
  const daysLeft = calcDaysLeft(endDate);
  const clampedRate = Math.min(Math.max(achievementRate, 0), 100);

  return (
    <CustomLink
      href={DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({ id: businessId })}
      aria-label={`${title} 상세 페이지로 이동`}
      className="flex w-full items-center gap-20 mobile-tablet:gap-14"
    >
      <div className="relative h-120 w-160 shrink-0 overflow-hidden rounded-medium ring-1 ring-inset ring-Gray-100 mobile-tablet:h-90 mobile-tablet:w-120">
        <Image
          fill
          sizes="(max-width: 1279px) 120px, 160px"
          src={thumbnailUrl}
          alt={title}
          className="object-cover"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-12 mobile-tablet:gap-8">
        <div className="flex w-full flex-col gap-2">
          <div className="flex w-full items-center justify-between gap-8 typo-caption1">
            <span className="truncate font-600 text-Gray-600">
              {institutionName}
            </span>
            {isEnded ? (
              <span className="shrink-0 font-400 text-Gray-550">마감</span>
            ) : (
              <span className="shrink-0 font-400 text-Gray-550">
                {daysLeft.toLocaleString()}일 남음
              </span>
            )}
          </div>
          <p className="line-clamp-1 w-full font-500 text-Gray-900 typo-body3 mobile-tablet:line-clamp-2 mobile-tablet:tracking-[-0.28px] mobile-tablet:typo-body4">
            {title}
          </p>
        </div>
        <div className="flex w-full flex-col gap-4 mobile-tablet:gap-2">
          <div className="h-4 w-full overflow-hidden rounded-pill bg-Gray-50">
            <div
              className="h-full rounded-pill bg-O-500"
              style={{ width: `${clampedRate}%` }}
            />
          </div>
          <div className="flex w-full items-center gap-4 font-600 typo-body4 mobile-tablet:typo-caption1">
            <span className="min-w-0 flex-1 truncate text-Gray-900">
              {donationAmount.toLocaleString()}원
            </span>
            <span className="shrink-0 text-right text-O-500">
              {clampedRate}%
            </span>
          </div>
        </div>
      </div>
    </CustomLink>
  );
}
